import { InitialState, CartActions, ValorizedCartState, UPDATE_PARAMS_CART } from './types'
import { status } from '../../typeStatus'
import {
  CART_RESET,
  CART_VALORIZED,
  CART_VALORIZED_ERROR,
  CART_VALORIZED_SUCCESS,
} from './interface-transactional-actions/cartValorized'
import {
  GET_CART_CACHE,
  GET_CART_CACHE_ERROR,
  GET_CART_CACHE_RESET,
  GET_CART_CACHE_SUCCESS,
} from './interface-transactional-actions/getCart'

const RESET_CART = CART_RESET || GET_CART_CACHE_RESET
const ValorizedCartReducer = (state: ValorizedCartState = InitialState, action: CartActions): ValorizedCartState => {
  switch (action.type) {
    case CART_VALORIZED: {
      return {
        ...state,
        statusCart: status.loading,
      }
    }
    case CART_VALORIZED_SUCCESS: {
      return {
        ...state,
        statusCart: status.success,
        cart: action.payload,
      }
    }
    case CART_VALORIZED_ERROR: {
      const statusErrorWithNumber = { loading: false, success: false, error: action.payload }
      return {
        ...state,
        statusCart: statusErrorWithNumber,
      }
    }
    case RESET_CART: {
      return {
        ...InitialState,
      }
    }
    case GET_CART_CACHE: {
      return {
        ...state,
        statusCacheCart: status.loading,
      }
    }
    case GET_CART_CACHE_SUCCESS: {
      return {
        ...state,
        statusCacheCart: status.success,
        cart: action.payload ? action.payload : InitialState.cart,
      }
    }
    case GET_CART_CACHE_ERROR: {
      return {
        ...state,
        statusCacheCart: status.error,
      }
    }

    case UPDATE_PARAMS_CART: {
      return {
        ...state,
        params: action.payload,
      }
    }
    default:
      return state
  }
}

export default ValorizedCartReducer
